module.exports = __webpack_public_path__ + "img/8a4cc83.webp";